import React from 'react'
import Link from 'next/link'
import { all_videos } from 'data/YoutubeVideos'
import { useRouter } from 'next/router'

function YoutubeTutorialsList() {
  const router = useRouter()
 
  return (
    <section className="relative">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pt-16 pb-12 md:pt-20 md:pb-20">
          {/* Page header */}
          <div className=" pb-12 md:pb-20 text-center md:text-left">
            <h1 className="h1">Tutorials - Guides - Demo  </h1>
          </div>

          {/* Section tags */}
          <div className="border-b border-gray-300 pb-4 mb-12">
            <ul className="flex flex-wrap justify-center md:justify-start font-medium -mx-5 -my-1">
              <li className="mx-5 my-1">
                <Link href="/tutorials" passHref>
                  <a
                    className={
                      router.pathname === '/tutorials'
                        ? 'text-blue-600'
                        : 'text-gray-800 hover:underline"'
                    }
                  >
                    All
                  </a>
                </Link>
              </li>
              <li className="mx-5 my-1">
                <Link href="/tutorials/building-series" passHref>
                  <a
                    className={
                      router.pathname === '/tutorials/building-series'
                        ? 'text-blue-600'
                        : 'text-gray-800 hover:underline"'
                    }
                  >
                    Building Series
                  </a>
                </Link>
              </li>
              <li className="mx-5 my-1">
                <Link href="/tutorials/features-demo">
                  <a
                    className={
                      router.pathname === '/tutorials/features-demo'
                        ? 'text-blue-600'
                        : 'text-gray-800 hover:underline"'
                    }
                  >
                    Features Demo
                  </a>
                </Link>
              </li>
              <li className="mx-5 my-1">
                <Link href="/tutorials/integrations" passHref>
                  <a
                    className={
                      router.pathname === '/tutorials/integrations'
                        ? 'text-blue-600'
                        : 'text-gray-800 hover:underline"'
                    }
                  >
                    Integrations
                  </a>
                </Link>
              </li>
              <li className="mx-5 my-1">
                <Link href="/tutorials/deployment">
                  <a
                    className={
                      router.pathname === '/tutorials/deployment'
                        ? 'text-blue-600'
                        : 'text-gray-800 hover:underline"'
                    }
                  >
                    Deployment
                  </a>
                </Link>
              </li>
              <li className="mx-5 my-1">
                <Link href="/tutorials/others">
                  <a
                    className={
                      router.pathname === '/tutorials/others'
                        ? 'text-blue-600'
                        : 'text-gray-800 hover:underline"'
                    }
                  >
                    Others
                  </a>
                </Link>
              </li>
            </ul>
          </div>

          {/* Articles list */}
          <div className="max-w-sm mx-auto md:max-w-none">
            {/* Articles container */}
            <div className="grid gap-12 md:grid-cols-3 md:gap-x-6 md:gap-y-8 items-start">
              {all_videos.map((item) => {
                if (router.pathname === '/tutorials') {
                  return (
                    <article className="flex flex-col h-full" data-aos="zoom-y-out">
                      <header>
                        <div className=" aspect-w-3 aspect-h-2 block mb-6">
                          <iframe
                            width="100%"
                            height="100%"
                            src={item.url}
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>

                        <div className="mb-3">
                          <ul className="flex flex-wrap text-xs font-medium -m-1">
                            {item.type && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-100 py-1 px-3 rounded-full bg-blue-500 hover:bg-blue-600 transition duration-150 ease-in-out">
                                  {item.type}
                                </a>
                              </li>
                            )}
                            {item.lavel && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-blue-100 hover:bg-blue-200 transition duration-150 ease-in-out">
                                  {item.lavel}
                                </a>
                              </li>
                            )}
                            {item.watch_time && (
                              <li className="m-1">
                                <span className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-white shadow-sm">
                                  {item.watch_time}
                                </span>
                              </li>
                            )}
                          </ul>
                        </div>
                        <h3 className="text-xl font-bold leading-snug tracking-tight mb-2">
                          <Link href={item.url}>
                            <a className="hover:underline">{item.title}</a>
                          </Link>
                        </h3>
                      </header>
                      {item?.description && (
                        <p className="text-gray-600 flex-grow">{item?.description}</p>
                      )}
                    </article>
                  )
                } else if (
                  router.pathname === '/tutorials/building-series' &&
                  item.type === 'Building Series'
                ) {
                  return (
                    <article className="flex flex-col h-full" data-aos="zoom-y-out">
                      <header>
                        <div className=" aspect-w-3 aspect-h-2 block mb-6">
                          <iframe
                            width="100%"
                            height="100%"
                            src={item.url}
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>

                        <div className="mb-3">
                          <ul className="flex flex-wrap text-xs font-medium -m-1">
                            {item.type && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-100 py-1 px-3 rounded-full bg-blue-500 hover:bg-blue-600 transition duration-150 ease-in-out">
                                  {item.type}
                                </a>
                              </li>
                            )}
                            {item.lavel && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-blue-100 hover:bg-blue-200 transition duration-150 ease-in-out">
                                  {item.lavel}
                                </a>
                              </li>
                            )}
                            {item.watch_time && (
                              <li className="m-1">
                                <span className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-white shadow-sm">
                                  {item.watch_time}
                                </span>
                              </li>
                            )}
                          </ul>
                        </div>
                        <h3 className="text-xl font-bold leading-snug tracking-tight mb-2">
                          <Link href={item.url}>
                            <a className="hover:underline">{item.title}</a>
                          </Link>
                        </h3>
                      </header>
                      {item?.description && (
                        <p className="text-gray-600 flex-grow">{item?.description}</p>
                      )}
                    </article>
                  )
                } else if (
                  router.pathname === '/tutorials/features-demo' &&
                  item.type === 'Features Demo'
                ) {
                  return (
                    <article className="flex flex-col h-full" data-aos="zoom-y-out">
                      <header>
                        <div className=" aspect-w-3 aspect-h-2 block mb-6">
                          <iframe
                            width="100%"
                            height="100%"
                            src={item.url}
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>

                        <div className="mb-3">
                          <ul className="flex flex-wrap text-xs font-medium -m-1">
                            {item.type && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-100 py-1 px-3 rounded-full bg-blue-500 hover:bg-blue-600 transition duration-150 ease-in-out">
                                  {item.type}
                                </a>
                              </li>
                            )}
                            {item.lavel && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-blue-100 hover:bg-blue-200 transition duration-150 ease-in-out">
                                  {item.lavel}
                                </a>
                              </li>
                            )}
                            {item.watch_time && (
                              <li className="m-1">
                                <span className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-white shadow-sm">
                                  {item.watch_time}
                                </span>
                              </li>
                            )}
                          </ul>
                        </div>
                        <h3 className="text-xl font-bold leading-snug tracking-tight mb-2">
                          <Link href={item.url}>
                            <a className="hover:underline">{item.title}</a>
                          </Link>
                        </h3>
                      </header>
                      {item?.description && (
                        <p className="text-gray-600 flex-grow">{item?.description}</p>
                      )}
                    </article>
                  )
                } else if (
                  router.pathname === '/tutorials/integrations' &&
                  item.type === 'Integrations'
                ) {
                  return (
                    <article className="flex flex-col h-full" data-aos="zoom-y-out">
                      <header>
                        <div className=" aspect-w-3 aspect-h-2 block mb-6">
                          <iframe
                            width="100%"
                            height="100%"
                            src={item.url}
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>

                        <div className="mb-3">
                          <ul className="flex flex-wrap text-xs font-medium -m-1">
                            {item.type && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-100 py-1 px-3 rounded-full bg-blue-500 hover:bg-blue-600 transition duration-150 ease-in-out">
                                  {item.type}
                                </a>
                              </li>
                            )}
                            {item.lavel && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-blue-100 hover:bg-blue-200 transition duration-150 ease-in-out">
                                  {item.lavel}
                                </a>
                              </li>
                            )}
                            {item.watch_time && (
                              <li className="m-1">
                                <span className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-white shadow-sm">
                                  {item.watch_time}
                                </span>
                              </li>
                            )}
                          </ul>
                        </div>
                        <h3 className="text-xl font-bold leading-snug tracking-tight mb-2">
                          <Link href={item.url}>
                            <a className="hover:underline">{item.title}</a>
                          </Link>
                        </h3>
                      </header>
                      {item?.description && (
                        <p className="text-gray-600 flex-grow">{item?.description}</p>
                      )}
                    </article>
                  )
                } else if (
                  router.pathname === '/tutorials/deployment' &&
                  item.type === 'Deployment'
                ) {
                  return (
                    <article className="flex flex-col h-full" data-aos="zoom-y-out">
                      <header>
                        <div className=" aspect-w-3 aspect-h-2 block mb-6">
                          <iframe
                            width="100%"
                            height="100%"
                            src={item.url}
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>

                        <div className="mb-3">
                          <ul className="flex flex-wrap text-xs font-medium -m-1">
                            {item.type && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-100 py-1 px-3 rounded-full bg-blue-500 hover:bg-blue-600 transition duration-150 ease-in-out">
                                  {item.type}
                                </a>
                              </li>
                            )}
                            {item.lavel && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-blue-100 hover:bg-blue-200 transition duration-150 ease-in-out">
                                  {item.lavel}
                                </a>
                              </li>
                            )}
                            {item.watch_time && (
                              <li className="m-1">
                                <span className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-white shadow-sm">
                                  {item.watch_time}
                                </span>
                              </li>
                            )}
                          </ul>
                        </div>
                        <h3 className="text-xl font-bold leading-snug tracking-tight mb-2">
                          <Link href={item.url}>
                            <a className="hover:underline">{item.title}</a>
                          </Link>
                        </h3>
                      </header>
                      {item?.description && (
                        <p className="text-gray-600 flex-grow">{item?.description}</p>
                      )}
                    </article>
                  )
                } else if (router.pathname === '/tutorials/others' && item.type === 'Others') {
                  return (
                    <article className="flex flex-col h-full" data-aos="zoom-y-out">
                      <header>
                        <div className=" aspect-w-3 aspect-h-2 block mb-6">
                          <iframe
                            width="100%"
                            height="100%"
                            src={item.url}
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>

                        <div className="mb-3">
                          <ul className="flex flex-wrap text-xs font-medium -m-1">
                            {item.type && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-100 py-1 px-3 rounded-full bg-blue-500 hover:bg-blue-600 transition duration-150 ease-in-out">
                                  {item.type}
                                </a>
                              </li>
                            )}
                            {item.lavel && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-blue-100 hover:bg-blue-200 transition duration-150 ease-in-out">
                                  {item.lavel}
                                </a>
                              </li>
                            )}
                            {item.watch_time && (
                              <li className="m-1">
                                <span className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-white shadow-sm">
                                  {item.watch_time}
                                </span>
                              </li>
                            )}
                          </ul>
                        </div>
                        <h3 className="text-xl font-bold leading-snug tracking-tight mb-2">
                          <Link href={item.url}>
                            <a className="hover:underline">{item.title}</a>
                          </Link>
                        </h3>
                      </header>
                      {item?.description && (
                        <p className="text-gray-600 flex-grow">{item?.description}</p>
                      )}
                    </article>
                  )
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default YoutubeTutorialsList
